// extracted by mini-css-extract-plugin
module.exports = {"container":"video-module--container--_m6F-"};